<template>
    <div class="embryo-previews">
        <embryo-preview v-for="(embryo, index) in embryos" :key="index" :embryo="embryo" />
    </div>
</template>

<script>
import EmbryoPreview from './EmbryoPreview'

export default {
    name: 'EmbryoPreviews',
    components: { EmbryoPreview },
    props: {
        embryos: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.embryo-previews {
    display: flex;
    overflow: auto;
    @include hide-scrollbar();

    @media screen and #{$new-break2close} {
        flex-direction: row;
    }
    @media screen and #{$new-break3open} {
        flex-direction: column;
    }
}
</style>
